import { PracticeTrialUpgradeBanner } from '@/components/modal/practice-trial-upgrade-banner';
import {
  TRIAL_EXTENSION_MODAL_CLASS,
  TRIAL_EXTENSION_OVERLAY_CLASS,
} from '@/components/modal/trial-extension/constants';
import {
  DialogDrawer,
  DialogDrawerContent,
} from '@heidi/design-system/mobile-responsive-dialog-drawer';
import { type ReactNode } from 'react';

interface TrialExtensionModalWrapperProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  /** When true, do not render the Practice upgrade banner (e.g. when modal uses its own footer/CTA). */
  hideUpgradeBanner?: boolean;
  /**
   * Suppress Radix focus return on close when a task CTA navigated away
   * (e.g. Work Home composer autofocus). See useTrialExtensionModalHandlers.
   */
  onCloseAutoFocus?: (event: Event) => void;
}

export function TrialExtensionModalWrapper({
  isOpen,
  onClose,
  children,
  hideUpgradeBanner = false,
  onCloseAutoFocus,
}: TrialExtensionModalWrapperProps) {
  return (
    <DialogDrawer open={isOpen} onOpenChange={onClose}>
      <DialogDrawerContent
        className={TRIAL_EXTENSION_MODAL_CLASS}
        overlayClassName={TRIAL_EXTENSION_OVERLAY_CLASS}
        onCloseIconClick={onClose}
        onCloseAutoFocus={onCloseAutoFocus}
      >
        <div className="flex flex-col gap-6 p-8">{children}</div>
        {!hideUpgradeBanner && <PracticeTrialUpgradeBanner onBeforeUpgrade={onClose} />}
      </DialogDrawerContent>
    </DialogDrawer>
  );
}
